import { FC } from 'app/FunctionalComponent'
import React from 'react'
import classes from './Filters.module.scss'

export const FilterSeparator: FC = (props: {}) => {
	return <div className={classes.filterSeparator}> | </div>
}
